/* Connectors & MCP (group "You"): connected apps with per-tool permissions, the connector catalog with
   OAuth / API-key connect (only for connectors the API reports available), remote MCP servers, webhooks and triggers, search across every
   connected app, export to connected apps, and this app as an MCP server and agent skill.
   API: api/src/modules/connectors/README.md (CONN-01..07). */
import { lazy } from 'react';
import { Plug } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'connectors',
  title: 'Connectors & MCP',
  short: 'Connectors',
  icon: Plug,
  group: 'You',
  route: '/connectors',
  order: 30,
  screen: lazy(() => import('./Screen.tsx')),
  capabilities: ['CONN-01', 'CONN-02', 'CONN-03', 'CONN-04', 'CONN-05', 'CONN-06', 'CONN-07', 'CONN-09', 'CONN-10'],
  commands: [
    { id: 'catalog', title: 'Connect an app', to: '/connectors/catalog', keywords: ['google', 'gmail', 'slack', 'github', 'oauth', 'integration'] },
    { id: 'mcp-add', title: 'Add an MCP server', to: '/connectors/mcp?add=1', keywords: ['mcp', 'server', 'tools', 'custom connector'] },
    { id: 'search', title: 'Search everything', to: '/connectors/search', keywords: ['enterprise', 'drive', 'slack', 'find'] },
    { id: 'webhook', title: 'New webhook', to: '/connectors/webhooks?new=1', keywords: ['zapier', 'make', 'n8n', 'automation', 'trigger'] },
    { id: 'export', title: 'Export to a connected app', to: '/connectors/export', keywords: ['notion', 'google doc', 'jira', 'github issue'] },
    { id: 'mcp-self', title: 'Use this app as an MCP server', to: '/connectors/mcp?sel=this-app', keywords: ['api key', 'skill', 'claude code', 'cursor'] },
  ],
});
